import React, { Component } from "react";
import Table from "react-bootstrap/Table";
import { OrderRequestFiles } from "../../request-details-files.component";
import { RequestOnBehalfDetails } from "../../request-on-behalf-details.component";
import Translation from "../../../../../common/translation/translation.component";

export class ReplaceSimDetails extends Component {
    constructor(props) {
        super(props);
    }

    handleShow = () => {
        this.setState({
            show: true
        });
    }

    render() {
        const { data } = this.props;
        return (
            <div>                
                <h4 className="order-detail-title"><Translation translationKey="order_request_details" /></h4>
                <div className="order-detail-location">
                    <RequestOnBehalfDetails robDetails={data.RequestedInBeHalfOf} isRob={data.Order.IsRequestedInBehalf} />
                    <Table>
                        <tbody>
                            <tr>
                                <td><Translation translationKey="order_number" /></td>
                                <td>{data.Order.OrderNumber}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="subscription_number" /></td>
                                <td>{data.Circuit.CircuitCode}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>{data.Subscription.PlanDetails.PlanName}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>{data.Subscription.VendorName}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>{data.SimType.SimTypeName}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>{data.Subscription && data.Subscription.SubscriptionDetailDevice ?
                                    data.Subscription.SubscriptionDetailDevice.EquipmentModel :
                                    <Translation translationKey="no_device_available" />} </td>
                            </tr>
                        </tbody>
                    </Table>
                    <h5 className="order-detail-location-title"><Translation translationKey="sim_replacement_request_details" /></h5>    
                    <Table>
                        <tbody>
                            <tr>
                                <td><Translation translationKey="new_sim_type" /></td>
                                <td>{data.NewRequest.SimType.SimTypeName}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="delivery_address" /></td>
                                <td>{data.Location === null ? data.OtherLocationName : data.Location.DeliveryAddress}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="additional_information" /></td>
                                <td>{data.BusinessJustification.AdditionalInformation}</td>
                            </tr>
                        </tbody>
                    </Table>
                </div>
            </div>
        );
    }
}